module.exports = __webpack_public_path__ + "static/media/virtualMeeting.e2923839.svg";